/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Only_Networks_With_History_HistoryInputs */

const fr_settings_only_networks_with_history_history = /** @type {(inputs: Settings_Only_Networks_With_History_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec historique`)
};

const en_settings_only_networks_with_history_history = /** @type {(inputs: Settings_Only_Networks_With_History_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With history`)
};

/**
* | output |
* | --- |
* | "With history" |
*
* @param {Settings_Only_Networks_With_History_HistoryInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_only_networks_with_history_history = /** @type {((inputs?: Settings_Only_Networks_With_History_HistoryInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Only_Networks_With_History_HistoryInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_only_networks_with_history_history(inputs)
	return en_settings_only_networks_with_history_history(inputs)
});